import React from 'react';
import { useIntegrations } from './hooks/useIntegrations';
import { IntegrationsHeader } from './components/IntegrationsHeader';
import { IntegrationsLoading } from './components/IntegrationsLoading';
import { IntegrationCard } from './components/IntegrationCard';
import { ConnectCalendarModal } from './components/ConnectCalendarModal';

export function Integrations() {
  const {
    isLoading,
    isGoogleConnected,
    googleEmail,
    isOutlookConnected,
    outlookEmail,
    isSalesforceConnected,
    sfEmail,
    isHubspotConnected,
    hubspotEmail,
    isModalOpen,
    modalProvider,
    manualEmail,
    setManualEmail,
    showManualInput,
    setShowManualInput,
    handleConnectSalesforce,
    handleDisconnectSalesforce,
    handleConnectHubspot,
    handleDisconnectHubspot,
    handleOAuthConnect,
    handleManualConnect,
    handleDisconnectCalendar,
    openConnectModal,
    closeModal
  } = useIntegrations();

  return (
    <div style={{ width: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '16px' }}>
      
      {/* ── Header ── */}
      <IntegrationsHeader />

      {/* ── Loading State vs Integrations List ── */}
      {isLoading ? (
        <IntegrationsLoading />
      ) : (
        <div id="tour-integrations-cards" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          
          {/* Google Calendar Card */}
          <IntegrationCard
            title="Google Calendar"
            icon={
              <svg viewBox="0 0 24 24" width="24" height="24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"/>
              </svg>
            }
            description="Sync Google Calendar meetings & events for automated briefings"
            isConnected={isGoogleConnected}
            activeEmail={googleEmail}
            onConnect={() => handleOAuthConnect('google')}
            onDisconnect={() => handleDisconnectCalendar('google')}
          />

          {/* Outlook Calendar Card */}
          <IntegrationCard
            title="Outlook Calendar"
            icon={
              <svg viewBox="0 0 23 23" width="22" height="22">
                <path fill="#f25022" d="M1 1h10v10H1z"/>
                <path fill="#7fba00" d="M12 1h10v10H12z"/>
                <path fill="#00a4ef" d="M1 12h10v10H1z"/>
                <path fill="#ffb900" d="M12 12h10v10H12z"/>
              </svg>
            }
            description="Sync Outlook Calendar meetings & events for automated briefings"
            isConnected={isOutlookConnected}
            activeEmail={outlookEmail}
            onConnect={() => handleOAuthConnect('outlook')}
            onDisconnect={() => handleDisconnectCalendar('outlook')}
          />

          {/* Salesforce Card */}
          <IntegrationCard
            title="Salesforce"
            icon={<img src="/logo-salesforce.png" alt="Salesforce" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />}
            description="Sync contacts, deals, and log call notes automatically"
            isConnected={isSalesforceConnected}
            activeEmail={sfEmail}
            onConnect={handleConnectSalesforce}
            onDisconnect={handleDisconnectSalesforce}
          />

          {/* HubSpot Card */}
          <IntegrationCard
            title="HubSpot"
            icon={<img src="/logo-hubspot.png" alt="HubSpot" style={{ width: '24px', height: '24px', objectFit: 'contain' }} />}
            description="Keep leads and activities updated in real-time"
            connectedDescription="Keep leads and activities updated in real-time"
            isConnected={isHubspotConnected}
            activeEmail={hubspotEmail}
            onConnect={handleConnectHubspot}
            onDisconnect={handleDisconnectHubspot}
          />

        </div>
      )}

      {/* ── Connect Modal ── */}
      <ConnectCalendarModal
        isOpen={isModalOpen}
        modalProvider={modalProvider}
        manualEmail={manualEmail}
        showManualInput={showManualInput}
        onClose={closeModal}
        onOAuthConnect={handleOAuthConnect}
        onManualConnect={handleManualConnect}
        setManualEmail={setManualEmail}
        setShowManualInput={setShowManualInput}
      />
    </div>
  );
}
